.form {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.form > :last-child {
    margin-top: auto;
}
